import { Box, Skeleton } from '@mui/material';
import { IconGraphy, Typography, colors } from '@leapeasy/ui-kit';
import { DetailPageState } from './DetailPageState';

const cardSx = {
  padding: '24px',
  gap: '10px',
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid #EAEAEA',
  background: 'white',
  borderRadius: '12px',
};

export const DetailPageShell = ({
  onBack,
  title,
  isLoading,
  hasError,
  onRetry,
  loadingLabel,
  skeletonVariant = 'fields',
  fieldCount = 7,
  tabCount = 7,
  sectionCount = 0,
  compact = false,
  children,
  footer,
}) => (
  <>
    <Box sx={cardSx}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: children || isLoading || hasError ? '16px' : 0,
        }}
      >
        <Box sx={{ cursor: 'pointer', '&:hover': { opacity: 0.75 } }}>
          <IconGraphy icon="Arrow.ArrowBack" onClick={onBack} />
        </Box>
        {isLoading && !title ? (
          <Skeleton variant="text" width={220} height={36} sx={{ ml: '15px' }} />
        ) : title ? (
          <Typography
            variant="h3"
            style={{
              color: colors.purple[900],
              fontWeight: '500',
              padding: '5px 5px 5px 15px',
            }}
          >
            {title}
          </Typography>
        ) : null}
      </Box>

      <DetailPageState
        isLoading={isLoading}
        hasError={hasError}
        onRetry={onRetry}
        loadingLabel={loadingLabel}
        skeletonVariant={skeletonVariant}
        fieldCount={fieldCount}
        tabCount={tabCount}
        sectionCount={isLoading ? sectionCount : 0}
        compact={compact}
      >
        {children}
      </DetailPageState>
    </Box>
    {footer}
  </>
);
